import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';

import { PropertyType } from 'src/generated/graphql';

type PropertyTypeStyleProps = {
    color: string;
    backgroundColor: string;
}

export const useStyles = makeStyles((theme) => ({
    container: {
        position: 'absolute',
        top: '0.5rem',
        right: '-0.5rem',
        border: `2px solid ${theme.palette.primary.main}`,
        padding: '0 0.5rem',
    },
    text: {
        color: ({ color }: PropertyTypeStyleProps) => color || theme.palette.primary.main,
        fontWeight: 'bold',
    },
}));

const getPropertyTypeStyles = (theme: Theme): { [key: string]: PropertyTypeStyleProps } => ({
    [PropertyType.Flexible]: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.tertiary.main,
    },
    [PropertyType.Managed]: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.tertiary.main,
    },
    default: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.common.white,
    },
});

type PropertyTypeBoxProps = {
    type: PropertyType;
    className?: string;
}

export const PropertyTypeBox = ({ type, className }: PropertyTypeBoxProps) => {
    const theme = useTheme();
    const propertyTypeStyles = getPropertyTypeStyles(theme);
    const propertyTypeStyle = propertyTypeStyles[type] || propertyTypeStyles.default;
    const classes = useStyles(propertyTypeStyle);

    return (
        <Box className={`${classes.container} ${className}`} bgcolor={propertyTypeStyle.backgroundColor}>
            <Typography variant="caption" className={classes.text}>{type}</Typography>
        </Box>
    );
};
